import request from '@/utils/request'
// 获取新闻侧边栏
// export function events_sidebar(params) {
// 	return request({
// 		url: '/information/events/sidebar',
// 		method: 'get',
// 	})
// }

// 获取事件列表
export function events_list(params) {
	return request({
		url: '/information/events/list',
		method: 'get',
		params: params,
	})
}

// 获取事件详情
export function events_detail(params) {
	return request({
		url: '/information/events/detail',
		method: 'get',
		params: params,
	})
}

// 新增事件
export function addEvents(params) {
	return request({
		url: '/information/events/create',
		method: 'post',
		data: params,
	})
}

// 更改事件状态
export function updateEventsStatus(params) {
	return request({
		url: '/information/events/update/status',
		method: 'post',
		data: params,
	})
}

// 删除新闻
export function deleteEvents(params) {
	return request({
		url: '/information/events/delete',
		method: 'post',
		data: params,
	})
}

// 编辑时--获取新闻原始参数
export function getParams(params) {
	return request({
		url: '/information/events/get',
		method: 'get',
		params: params,
	})
}

// 编辑新闻
export function editEvents(params) {
	return request({
		url: '/information/events/update',
		method: 'post',
		data: params,
	})
}
